export default "query GetGroupTree {\n  getGroupTree {\n    id\n    name\n    parentId\n  }\n}"